module.exports = __webpack_public_path__ + "static/media/sgen_snap01.e5987f2d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/sgen_snap01.png
// module id = 68
// module chunks = 0